import {
  Box,
  BoxProps,
  Group,
  GroupProps,
  Paper,
  Skeleton,
  ThemeIcon,
  ThemeIconProps,
  Title,
} from "@mantine/core";
import { IconChevronRight, IconProps as TablerIconProps } from "@tabler/icons-react";

import { MantineTabler } from "ui/components/mantine-tabler";
import { SIDENAV_LOGO_HEIGHT_PX } from "ui/theme/cssVariablesResolver";

const HORIZONTAL_PADDING = "lg";

export function TableParent({
  children,
  loading = false,
  ...boxProps
}: BoxProps & { loading?: boolean }) {
  return (
    <Box flex={1} pb="lg" px={HORIZONTAL_PADDING} h="100%" {...boxProps}>
      <Skeleton visible={loading} h="100%">
        <Paper h="100%" withBorder>
          {children}
        </Paper>
      </Skeleton>
    </Box>
  );
}

export type PageHeadingProps = {
  icon: React.FC<TablerIconProps> | React.ReactNode;
  title: React.ReactNode;
  breadcrumb?: React.ReactNode;
  color: ThemeIconProps["color"];
  rightSection?: React.ReactNode;
  loading?: boolean;
} & Omit<GroupProps, "title" | "children">;

export function PageHeading({
  icon: Icon,
  title,
  breadcrumb,
  color,
  rightSection = null,
  loading = false,
  ...groupProps
}: PageHeadingProps) {
  return (
    <Group
      justify="space-between"
      px={HORIZONTAL_PADDING}
      pt="var(--sidenav-spacing-y)"
      pb="var(--sidenav-spacing-y)"
      w="100%"
      {...groupProps}
    >
      <Group gap="lg">
        <Skeleton h={SIDENAV_LOGO_HEIGHT_PX} w={SIDENAV_LOGO_HEIGHT_PX} visible={loading}>
          <ThemeIcon color={color} variant="radiant" size={SIDENAV_LOGO_HEIGHT_PX}>
            {/* @ts-expect-error  TS2604 */}
            <Icon />
          </ThemeIcon>
        </Skeleton>
        <Group>
          <Box>
            <Skeleton visible={loading}>
              {typeof title === "string" ? (
                <Title order={4} c={breadcrumb ? "gray.6" : undefined}>
                  {title}
                </Title>
              ) : (
                title
              )}
            </Skeleton>
          </Box>
          {breadcrumb && (
            <>
              <MantineTabler icon={IconChevronRight} color="gray.5" size={16} />
              <Title order={5}>{breadcrumb}</Title>
            </>
          )}
        </Group>
      </Group>
      {rightSection}
    </Group>
  );
}

export function PageTabsParent({ children, ...boxProps }: BoxProps) {
  return (
    <Box px="lg" {...boxProps}>
      <Box mt={-8}>{children}</Box>
    </Box>
  );
}
